// extracted by mini-css-extract-plugin
export default {"home_page":"HomePage_home_page__Vhh3U","loading":"HomePage_loading__8TwWn","blurb":"HomePage_blurb__1wvHE","error":"HomePage_error__BuD9v"};